<template>
  <div id="app">
    <v-app>
      <login-component v-if="!$session.user" />
      <router-view v-else-if="$session.sopen" />
      <div v-else class="pa-4 text--disabled">CONNECTING...</div>

      <modal-component />
    </v-app>
  </div>
</template>

<script>
import LoginComponent from './views/Login'
import ModalComponent from '@/components/Modal'
export default {
  components: {LoginComponent, ModalComponent},
  created () {
    const locale = localStorage.getItem('locale') || 'en'
    this.$vuetify.lang.current = locale
    this.$moment.locale(locale)
  }
}
</script>

<style lang="scss">
  .detail-view {
    position: fixed;
    top: 48px;
    right: 0;
    background-color: rgba(0,0,0,0.9);
    // width: 70%;
    // width: calc(100% - 100px);
    // height: calc(100vh - 48px);
    width: 980px;
    z-index: 5;
  }

  .detail-enter-active {
    transition: transform .5s, box-shadow .5s;
  }

  .detail-leave-active {
    transition: transform .5s, box-shadow .5s;
  }

  .detail-enter {
    transform: translateX(100%);
    box-shadow: -2px 0px 20px rgba(0,0,0,0.5);
  }

  .detail-leave-to {
    transform: translateX(100%);
    box-shadow: -2px 0px 20px rgba(0,0,0,0.5);
  }
</style>
